// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ----------------------------------------
 * animation fade-in-bottom
 * ----------------------------------------
 */
@keyframes fade-in-bottom {
	0% {
		transform: translateY(20px);
		opacity: 0;
	}
	100% {
		transform: translateY(0);
		opacity: 1;
	}
}
@keyframes fade-out-bottom {
	0% {
		/* -webkit-transform: translateY(0);
		transform: translateY(0); */
		opacity: 1;
	}
	100% {
		/* -webkit-transform: translateY(50px);
		transform: translateY(50px); */
		opacity: 0;
	}
}

.fade-in-bottom {
	animation: fade-in-bottom 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}

.fade-out-bottom {
	animation: fade-out-bottom 0.2s ease-out both;
}

.Toastify__toast-container {
	width: unset;
}

.Toastify__toast {
	display: flex;
	grid-gap: 8px;
	gap: 8px;
	min-height: unset;
	font-family: unset;
	margin-bottom: 8px;
	border-radius: 6px;
	padding: 8px 8px 10px 12px;
	backdrop-filter: blur(10px);
	max-width: 350px;
}

.Toastify__toast--success {
	background-color: rgba(3, 109, 50, 0.164);
	border: 1px solid rgb(7, 173, 82);
	color: var(--typography-primary);
}

.Toastify__toast--error {
	background-color: rgba(109, 3, 3, 0.164);
	border: 1px solid rgb(173, 7, 7);
	color: var(--typography-primary);
}

.Toastify__toast-body {
	padding: 0;
}

.Toastify__close-button > svg {
	width: 24px;
	margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Toast/toastTransition.css"],"names":[],"mappings":"AAAA;;;;EAIE;AAaF;CACC;EAEC,2BAA2B;EAC3B,UAAU;CACX;CACA;EAEC,wBAAwB;EACxB,UAAU;CACX;AACD;AAcA;CACC;EACC;6BAC2B;EAC3B,UAAU;CACX;CACA;EACC;gCAC8B;EAC9B,UAAU;CACX;AACD;;AAEA;CAEC,6DAA6D;AAC9D;;AAEA;CAEC,6CAA6C;AAC9C;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,aAAQ;CAAR,QAAQ;CACR,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,0BAA0B;CAC1B,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;CACzC,iCAAiC;CACjC,gCAAgC;AACjC;;AAEA;CACC,wCAAwC;CACxC,gCAAgC;CAChC,gCAAgC;AACjC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,eAAe;AAChB","sourcesContent":["/**\n * ----------------------------------------\n * animation fade-in-bottom\n * ----------------------------------------\n */\n@-webkit-keyframes fade-in-bottom {\n\t0% {\n\t\t-webkit-transform: translateY(20px);\n\t\ttransform: translateY(20px);\n\t\topacity: 0;\n\t}\n\t100% {\n\t\t-webkit-transform: translateY(0);\n\t\ttransform: translateY(0);\n\t\topacity: 1;\n\t}\n}\n@keyframes fade-in-bottom {\n\t0% {\n\t\t-webkit-transform: translateY(20px);\n\t\ttransform: translateY(20px);\n\t\topacity: 0;\n\t}\n\t100% {\n\t\t-webkit-transform: translateY(0);\n\t\ttransform: translateY(0);\n\t\topacity: 1;\n\t}\n}\n\n@-webkit-keyframes fade-out-bottom {\n\t0% {\n\t\t/* -webkit-transform: translateY(0);\n\t\ttransform: translateY(0); */\n\t\topacity: 1;\n\t}\n\t100% {\n\t\t/* -webkit-transform: translateY(50px);\n\t\ttransform: translateY(50px); */\n\t\topacity: 0;\n\t}\n}\n@keyframes fade-out-bottom {\n\t0% {\n\t\t/* -webkit-transform: translateY(0);\n\t\ttransform: translateY(0); */\n\t\topacity: 1;\n\t}\n\t100% {\n\t\t/* -webkit-transform: translateY(50px);\n\t\ttransform: translateY(50px); */\n\t\topacity: 0;\n\t}\n}\n\n.fade-in-bottom {\n\t-webkit-animation: fade-in-bottom 0.3s cubic-bezier(0.23, 1, 0.32, 1);\n\tanimation: fade-in-bottom 0.3s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.fade-out-bottom {\n\t-webkit-animation: fade-out-bottom 0.2s ease-out both;\n\tanimation: fade-out-bottom 0.2s ease-out both;\n}\n\n.Toastify__toast-container {\n\twidth: unset;\n}\n\n.Toastify__toast {\n\tdisplay: flex;\n\tgap: 8px;\n\tmin-height: unset;\n\tfont-family: unset;\n\tmargin-bottom: 8px;\n\tborder-radius: 6px;\n\tpadding: 8px 8px 10px 12px;\n\tbackdrop-filter: blur(10px);\n\tmax-width: 350px;\n}\n\n.Toastify__toast--success {\n\tbackground-color: rgba(3, 109, 50, 0.164);\n\tborder: 1px solid rgb(7, 173, 82);\n\tcolor: var(--typography-primary);\n}\n\n.Toastify__toast--error {\n\tbackground-color: rgba(109, 3, 3, 0.164);\n\tborder: 1px solid rgb(173, 7, 7);\n\tcolor: var(--typography-primary);\n}\n\n.Toastify__toast-body {\n\tpadding: 0;\n}\n\n.Toastify__close-button > svg {\n\twidth: 24px;\n\tmargin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
